<template>
  <div id="zcyys">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'zcyys'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/exhibitors/zcyys/Zcyys.vue